import { Badge } from "@/components/ui/badge";
import { getStatusColor, getStatusLabel, type ComplianceTask } from "@/utils/complianceScore";

interface TaskStatusBadgeProps {
  status: ComplianceTask['status'];
  className?: string;
}

export function TaskStatusBadge({ status, className = "" }: TaskStatusBadgeProps) {
  const colorClass = getStatusColor(status);
  const label = getStatusLabel(status);

  return (
    <Badge
      variant="secondary"
      className={`${colorClass} ${className}`}
    >
      {label}
    </Badge>
  );
}

